import Ws from './Ws'
import UtilsDecrypt from './UtilsDecrypt';

export default class LocalStorage{

    localUserKey = "localUserKey";
    localUserPreferencesKey = "localUserPreferences"
    localEvKey = "localEvKey"

    // USER DATA REGION
    GetUserData = () => {


        let u = new UtilsDecrypt();

        if( localStorage.getItem(this.localUserKey)){
            let ud = u.decryptText(localStorage.getItem(this.localUserKey))
            return JSON.parse(ud);
        }
        else
            return null;
    }


   

    SetUserData = (us) => {
        let u = new UtilsDecrypt();
        if(us){         
            localStorage.setItem(this.localUserKey,u.encryptText(JSON.stringify(us)))
            return true
        }
        else{
            localStorage.setItem(this.localUserKey, null)
            return false
        }
    }

    SetEtapaId = (us) =>{
        let u = new UtilsDecrypt();
        if(us){         
            localStorage.setItem('etapaId',u.encryptText(JSON.stringify(us)))
            return true
        }
        else{
            localStorage.setItem('etapaId', null)
            return false
        }
    }

    GetEtapaId = () => {


        let u = new UtilsDecrypt();

        if( localStorage.getItem('etapaId')){
            let ud = u.decryptText(localStorage.getItem('etapaId'))
            return JSON.parse(ud);
        }
        else
            return null;
    }

    // USER PREFERENCES
    userPreferencesObjectModel = {
        language:'ro',
        projectView:'list' , //
        theme:'light',
    }

    GetUserPreferences = () => {

        this.CheckModelVsLocalStorage()

        if( localStorage.getItem(this.localUserPreferencesKey)){
            let ud = localStorage.getItem(this.localUserPreferencesKey)

            // console.log('Local preferences settings = ', ud)

            return JSON.parse(ud);
        }
        else{
            localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(this.userPreferencesObjectModel))
            // console.warn("No local preferences were found. Default values applyed")
            return this.userPreferencesObjectModel
        }
    }
 
    SetUserPreferences = (key,value) => {
        // daca cheia exista in model object
        this.CheckModelVsLocalStorage()

        if(this.userPreferencesObjectModel[key]){

            if( localStorage.getItem(this.localUserPreferencesKey)){

                let lPref =  localStorage.getItem(this.localUserPreferencesKey);
               
                lPref = JSON.parse(lPref);
                lPref[key] = value;

                localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(lPref))
                return true;
            }
            else{
                // console.warn("User preferences not found. Object will be created.")
                
                let lPref = this.userPreferencesObjectModel;
                lPref[key] = value;

                localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(lPref))
                return true;
            }

        }
        else{
            // daca cheia nu exista in object model, nu salvam: se pierde controlul in structura obiectului
            console.error("ERR: key not in preferences object model. Operation is not permited.")
            return false;
        }
    }

    CheckModelVsLocalStorage = () => {
        if( localStorage.getItem(this.localUserPreferencesKey)){
            
            let ud = localStorage.getItem(this.localUserPreferencesKey)
            ud = JSON.parse(ud);

            let shouldUpdate = false
            for(let k in  this.userPreferencesObjectModel  ){
                // console.log('Key analized = ', k )
                if(!ud.hasOwnProperty(k)){
                    shouldUpdate = true;
                    ud[k] = this.userPreferencesObjectModel[k]
                    // console.warn("User preferences object model key "+k+" not found and prepare to add")
                }

                if(shouldUpdate){
                    localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(ud))
                    // console.warn("New keys successfully added in local user preferences")
                }
            }
        }
        else{
            localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(this.userPreferencesObjectModel))
            // console.warn("Cheking local preferences: No local preferences were found. Default values applyed")
        }
    }

    SetDefaultPreferences = ()=>{
        // console.log('Model is = ', this.userPreferencesObjectModel )
        // console.log('Stringified model is = ', JSON.stringify(this.userPreferencesObjectModel) )

        localStorage.setItem(this.localUserPreferencesKey, JSON.stringify(this.userPreferencesObjectModel))
        // console.log("Preferences default applyed")
        return true;
    }



    GetEvaluareData = () => {


        let u = new UtilsDecrypt();

        if( localStorage.getItem(this.localEvKey)){
            let ud = u.decryptText(localStorage.getItem(this.localEvKey))
            return JSON.parse(ud);
        }
        else
            return null;
    }


   

    SetEvaluareData = (us) => {
        let u = new UtilsDecrypt();
        if(us){         
            localStorage.setItem(this.localEvKey,u.encryptText(JSON.stringify(us)))
            return true
        }
        else{
            localStorage.setItem(this.localEvKey, null)
            return false
        }
    }

}